import ApplicationSerializer from "./application";

export default class ServerTemplateSerializer extends ApplicationSerializer {
  usesProxy = true;

  getPayload(payload) {
    return Object.values(super.getPayload(payload)).flat();
  }

  normalize(modelClass, resourceHash, prop) {
    let template = {
      id: resourceHash.id,
      basecost: resourceHash.instancecost.amount,
      bootstrapMethod: resourceHash.bootstrapmethod,
      licensecost: resourceHash.licensecost.amount,
      minimumDiskSize: resourceHash.minimumdisksize,
      minimumMemorySize: resourceHash.minimummemorysize,
      platform: resourceHash.platform,
      supportsCloudInitSshKeys: resourceHash.supportscloudinitsshkeys,
      templateId: resourceHash.id,
      value: resourceHash.name,
    };

    return super.normalize(modelClass, template, prop);
  }
}
